import React, { useContext } from "react";
import styles from './PasswordStrengthIndicator.module.scss';

import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../utils/translations/PasswordStrengthIndicatorTranslations';

const PasswordStrengthIndicator = ({ password }) => {

  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.fr;

  const getStrength = () => {
    let strength = 0;
    if (password.length >= 12) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[\W_]/.test(password)) strength++;

    return strength;
  };

  const strength = getStrength();
  const colors = ["#cf5f53ff", "#f8b16bff", "#f6d36aff", "rgb(193, 216, 180)", "rgb(125, 163, 102)"];
  const colorsDarken = ["#b32b1cff", "#d3700eff", "#d2a520ff", "rgba(98, 169, 56, 1)", "rgba(72, 118, 44, 1)"];
  const labels = [t.veryWeak, t.weak, t.medium, t.strong, t.veryStrong];

  return (
    <div className={styles.passwordStrength}>
      <div
        style={{
          width: `${(strength / 5) * 100}%`,
          backgroundColor: colors[strength - 1] || "#ddd",
        }}
      ></div>
      <p 
        className={styles.label}
        style={{
          color: colorsDarken[strength - 1] || "#ddd",
        }}
      >{labels[strength - 1] || "Très faible"}</p>
    </div>
  );
};

export default PasswordStrengthIndicator;